import { createActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import paymentsApi from '../../api/paymentsApi';
import Auth from '../../api/auth';
import { Dispatch } from 'react';
import { Context } from '../../types';

const {
  generateAuthCodePending,
  generateAuthCodeFulfilled,
  generateAuthCodeRejected,
  getTokenByAuthCodePending,
  getTokenByAuthCodeFulfilled,
  getTokenByAuthCodeRejected,
  setLoginStep,
} = createActions(
  actionTypes.GENERATE_AUTH_CODE_PENDING,
  actionTypes.GENERATE_AUTH_CODE_FULFILLED,
  actionTypes.GENERATE_AUTH_CODE_REJECTED,
  actionTypes.GET_TOKEN_BY_AUTH_CODE_PENDING,
  actionTypes.GET_TOKEN_BY_AUTH_CODE_FULFILLED,
  actionTypes.GET_TOKEN_BY_AUTH_CODE_REJECTED,
  actionTypes.SET_LOGIN_STEP,
  getActionOptions(ACTION_PREFIX)
);

const getPaymentsCode = (id: any, mobileNumber: string) => (dispatch: Dispatch<any>) => {
  dispatch(generateAuthCodePending());

  return paymentsApi
    .sendAuthenticationCode(id, mobileNumber, Context.linkAccount.toLocaleString())
    .then((response) => {
      return dispatch(generateAuthCodeFulfilled({ mobileNumber, ...response.data }));
    })
    .catch((error) => {
      return dispatch(generateAuthCodeRejected(error));
    });
};

const getPaymentsTokenByAuthCode = (id: string, mobileNumber: string, code: string) => (dispatch: Dispatch<any>) => {
  dispatch(getTokenByAuthCodePending());

  return paymentsApi
    .getPaymentsTokenByAuthCode(id, mobileNumber, code, Context.linkAccount.toLocaleString())
    .then((response) => {
      Auth.loggedIn(response.data);
      return dispatch(getTokenByAuthCodeFulfilled(response));
    })
    .catch((error) => {
      return dispatch(getTokenByAuthCodeRejected(error));
    });
};

export default {
  getPaymentsCode,
  getPaymentsTokenByAuthCode,
  setLoginStep,
  generateAuthCodeFulfilled,
  getTokenByAuthCodeFulfilled,
};
